import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import DialogContentText from "@mui/material/DialogContentText";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Tools from "./JNSTools";
import "./styles/MainToolbar.css";
import { CredsContext } from "./Contexts";

function SettingsStartingDashboardPage(props) {
  let settings;
  const settingsRaw = localStorage.getItem("oadaSettings");
  if (settingsRaw) {
    settings = JSON.parse(settingsRaw);
  }
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const [value, setValue] = useState(
    settings
      ? settings.startingDashboardScreen
        ? settings.startingDashboardScreen
        : "Dashboard"
      : "Dashboard",
  );

  const handleChange = (event) => {
    settings.startingDashboardScreen = event.target.value;
    localStorage.setItem("oadaSettings", JSON.stringify(settings));
    Tools.writeSettings(creds);
    setValue(event.target.value);
  };

  return (
    <>
      <DialogContentText id="alert-dialog-description" sx={{ color: "white" }}>
        Starting tab:
      </DialogContentText>
      <Select
        className="settingsSelectBox"
        value={value}
        name="startingDashboardScreen"
        onChange={handleChange}
      >
        <MenuItem value={"Dashboard"}>Dashboard</MenuItem>
        <MenuItem value={"Gantt"}>Gantt</MenuItem>
        <MenuItem value={"Messages"}>Messages</MenuItem>
        <MenuItem value={"RAID"}>RAID Log</MenuItem>
        <MenuItem value={"Requirements"}>Requirements</MenuItem>
        <MenuItem value={"Change Log"}>Change Log</MenuItem>
      </Select>
    </>
  );
}

export default SettingsStartingDashboardPage;

SettingsStartingDashboardPage.propTypes = {
  handleSettingsChange: PropTypes.func,
};
